import axios from 'axios';

const client = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/admin`,
  withCredentials: true,
});

export default client;
